import { AxiosConfigAdmin } from "Admin/Config/AxiosConfig";
import { refreshToken } from "./Auth";
export const getProfileSummary = (callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/summary`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfileSummary(callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const updateProfileSummary = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/summary`;

  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => updateProfileSummary(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const getProfileVideo = (callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/videoPresentations`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfileVideo(callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const addProfileVideo = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/videoPresentations`;
  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => addProfileVideo(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const deleteProfileVideo = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/videoPresentations/removeVideo`;

  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => deleteProfileVideo(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getProfilePublication = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/publications?page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfilePublication(page, rowsPerPage, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getProfileGrants = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/grants?page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfileGrants(page, rowsPerPage, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const getProfileHonors = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/honors?entity_type=${3}&page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfileHonors(page, rowsPerPage, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const createProfileHonor = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/honors`;

  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => createProfileHonor(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const deleteProfileHonor = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/honors`;

  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => deleteProfileHonor(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getProfileExperiences = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/experiences?page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfileExperiences(page, rowsPerPage, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const createProfileExperience = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/experiences`;
  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => createProfileExperience(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const deleteProfileExperience = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/experiences`;

  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => deleteProfileExperience(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getProfileEducation = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/education?entity_type=${3}&page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getProfileEducation(page, rowsPerPage, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const createProfileEducation = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/education`;

  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => createProfileEducation(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const deleteProfileEducation = (payload, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/education`;

  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => deleteProfileEducation(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getProfileCollaborators = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/profile/collaborators?entity_type=${3}&page=${page}&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() =>
          getProfileCollaborators(page, rowsPerPage, callback)
        );
      } else {
        callback(err.response.data);
      }
    });
};
